import * as ActionTypes from '../actionTypes';

export const partValidation = (state = {}, action) => {
	switch (action.type) {
		case ActionTypes.UPDATE_PART_VALIDATION:
			return {
				...state,
				parentPartDescription: action.parentPartDescription,
				parentPartNumber: action.parentPartNumber,
				scanJobDetails: action.scanJobDetails,
				sequenceNumber: action.sequenceNumber,
				serialNumber: action.serialNumber,
				isExceptionRaised: action.isExceptionRaised,
			};
		default:
			return state;
	}
};
